// All MJTI landing-page copy lives here. Edit these strings to update the page.
// Keep it warm, first-person, written. No "we" — Jennie is solo.

export const mjtiContent = {
  hero: {
    eyebrow: "Early access for MJTI members",
    headline: "Welcome!",
    body: [
      "Hi, I'm Jennie. I'm a mah jongg enthusiast who loves to play and analyze the annual card. MahjSpace is an app I built to help American Mah Jongg players track their winning hands, and start to notice patterns in their own game. You can log photos and memories from each one. Sharing with friends is optional!",
      "If you're like me, you probably find that you're playing the same section or hands all year. If we can see which hands we always favor, we can begin to pivot and adapt to try new ones. It starts with tracking. This is a fun way to chart progress and set goals.",
      "Johni is offering early access to you, so I can get your honest feedback before opening up to a wider audience.",
      "Thank you, and cheers! 🐦",
    ],
  },

  screenshots: [
    {
      caption: "The 2026 card is all in one place. Tap a hand to log a win.",
      src: "/mjti-screenshots/tracker.png",
      alt: "MahjSpace tracker showing the 2026 NMJL card with progress bar",
    },
    {
      caption: "Log every win. Start to notice patterns in your game play!",
      src: "/mjti-screenshots/win-list.png",
      alt: "Wins-on-this-hand modal showing multiple logged wins for one hand",
    },
    {
      caption: "Snap a photo, jot a note — save the moment.",
      src: "/mjti-screenshots/evidence.jpg",
      alt: "Evidence card with photo, date, location, and notes for a logged win",
    },
    {
      caption: "See how your friends are doing, and cheer each other on!",
      src: "/mjti-screenshots/friends.png",
      alt: "Friends tab showing progress comparison and friend requests",
    },
  ],

  benefits: {
    heading: "What you get in early access",
    items: [
      "The full app, free during early access.",
      "A direct line to me — every piece of feedback shapes what gets built next.",
      "First access to new features as they ship.",
    ],
  },

  signupForm: {
    heading: "Claim your spot",
    nameLabel: "Name",
    namePlaceholder: "So I know what to call you",
    emailLabel: "Email",
    emailPlaceholder: "you@example.com",
    passwordLabel: "Password",
    passwordPlaceholder: "Make it memorable",
    submit: "Sign up free",
  },

  footer: {
    tagline: "Made for MJTI players.",
    instagramUrl: "https://instagram.com/mahjspace",
    facebookUrl: "https://facebook.com/mahjspace",
    contactEmail: "support@mahjspace.com",
  },
};
